import PropTypes from 'prop-types';
import React from 'react';

import { bibFieldShape } from '@bibliocommons/bc-prop-types';
import { ExpandableList } from '@bibliocommons/expandable';

import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';

import './CatalogContributors.scss';

const MAX_CONTRIBUTORS_DISPLAYED = 3;

export default function CatalogContributors({ contributorNames, trackFieldItemClick }) {
  const values = contributorNames.get('fieldValues');

  const getItemKey = item => item.getIn(['primary', 'values', 0]);
  const renderContributor = contributor => {
    return <FieldValue value={contributor} handleClick={() => trackFieldItemClick(contributorNames, contributor)} />;
  };

  return (
    <div className="cp-catalog-contributors">
      <ExpandableList
        list={values}
        getItemKey={getItemKey}
        renderItem={renderContributor}
        collapseCount={MAX_CONTRIBUTORS_DISPLAYED}
        expandLinkHref="#show-more-contributors"
        stacked
        textKey="contributors"
      />
    </div>
  );
}

CatalogContributors.propTypes = {
  contributorNames: bibFieldShape.isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};
